import { ActionTypes } from '../constants/actionTypes/hotelSearch';

const initialState = {
  isInitialized: false,
};

const hotelSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.HOTEL_SEARCH_CONTROL_INIT_SUCCESS:
      return {
        ...state,
        labels: action.labels,
        isInitialized: true,
        isLoading: true,
      };
    case ActionTypes.HOTEL_SEARCH_CONTROL_SEARCH_INFO_MISSING:
      return {
        ...state,
        searchInfoMissing: true,
        isLoading: false,
      };
    case ActionTypes.HOTEL_SEARCH_CONTROL_GET_INIT_STATE:
      return {
        ...state,
        isLoading: true,
      };

    case ActionTypes.HOTEL_SEARCH_CONTROL_GET_INIT_STATE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        selectedHotelId: action.data.hotelId,
        selectedResortId: action.data.resortId,
        departures: action.data.departureAirports,
        selectedDeparture: action.data.selectedDepartureAirport,
        durations: action.data.durations,
        selectedDuration: action.data.selectedDuration,
        departureDates: action.data.departureDates,
        selectedDepartureDate: action.data.selectedDepartureDate,
        selectedReturnDate: action.data.selectedReturnDate,
        selectedNumberOfRooms: action.data.selectedNumberOfRooms,
        rooms: action.data.rooms,
        showPriceCalendar: false,
        showDirectFlights: false,
        priceCalendarDurationOptions: action.data.options,
        priceCalendarData: {},
        previousDuration: null,
        siteSettings: action.siteSettings,
      };

    case ActionTypes.HOTEL_SEARCH_CONTROL_CHANGE_DEPARTURE:
      return {
        ...state,
        selectedDeparture: action.departure,
      };

    case ActionTypes.HOTEL_SEARCH_CONTROL_GET_DURATIONS_SUCCESS:
      return {
        ...state,
        durations: action.durations,
        selectedDuration: action.selectedDuration,
        priceCalendarDurationOptions: action.options,
      };

    case ActionTypes.HOTEL_SEARCH_CONTROL_CHANGE_DURATION:
      return {
        ...state,
        selectedDuration: action.duration,
      };

    case ActionTypes.HOTEL_SEARCH_CONTROL_GET_DEPARTURE_DATES_SUCCESS:
      return {
        ...state,
        departureDates: action.departureDates,
        selectedDepartureDate: action.selectedDepartureDate,
        selectedReturnDate: action.selectedReturnDate,
      };

    case ActionTypes.HOTEL_SEARCH_CONTROL_CHANGE_DATES:
      return {
        ...state,
        selectedDepartureDate: action.selectedDepartureDate,
        selectedReturnDate: action.selectedReturnDate,
      };

    case ActionTypes.HOTEL_SEARCH_CONTROL_CHANGE_ROOM_DISTRIBUTION:
      return {
        ...state,
        rooms: action.roomDistribution,
        selectedNumberOfRooms: action.selectedNumberOfRooms,
      };

    case ActionTypes.HOTEL_SEARCH_CONTROL_SET_SHOW_PRICE_CALENDAR:
      return {
        ...state,
        showPriceCalendar: action.showPriceCalendar,
      };

    case ActionTypes.HOTEL_SEARCH_CONTROL_SET_SHOW_DIRECT_FLIGHTS:
      return {
        ...state,
        showDirectFlights: action.showDirectFlights,
      };

    case ActionTypes.HOTEL_SEARCH_CONTROL_GET_PRICE_CALENDAR_DATA_SUCCESS:
      return {
        ...state,
        priceCalendarData: {
          ...action.priceCalendarData,
        },
      };

    case ActionTypes.HOTEL_SEARCH_CONTROL_SET_PREVIOUS_DURATION:
      return {
        ...state,
        previousDuration: action.previousDuration,
      };

    default:
      return state;
  }
};

export default hotelSearchReducer;
